export default "__VITE_ASSET__BiEqBogN__"